import { render, staticRenderFns } from "./ResultRankList.vue?vue&type=template&id=6b0b9754&"
import script from "./ResultRankList.vue?vue&type=script&lang=ts&"
export * from "./ResultRankList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports